import { render, staticRenderFns } from "./tagsInternalReview.vue?vue&type=template&id=42ba1340&scoped=true&lang=pug"
import script from "./tagsInternalReview.vue?vue&type=script&lang=js"
export * from "./tagsInternalReview.vue?vue&type=script&lang=js"
import style0 from "./tagsInternalReview.vue?vue&type=style&index=0&id=42ba1340&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ba1340",
  null
  
)

export default component.exports